import { defineStore } from 'pinia'

export const useI18NStore = defineStore('i18n', () => {
  const hreflang = ref({})

  return { hreflang }
})
